/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
export class Permission {
  create: boolean;
  read: boolean;
  update: boolean;
  delete: boolean;

  constructor(create: boolean, read: boolean, update: boolean, deleteParam: boolean) {
    this.create = create;
    this.read = read;
    this.update = update;
    this.delete = deleteParam;
  }

}
